import React from 'react';
import PropTypes from 'prop-types';
import StylePropType from 'react-style-proptype';
import Radium from 'radium';
import Styles from './styles';

class Input extends React.Component {
  render() {
    const {
      style,
      extra,
      error,
      showRequired,
      validations,
      validationMsg,
      forceBackground,
      accessory,
      ...inputProps
    } = this.props;

    const showBackground =
      Radium.getState(this.state, 'input', ':focus') || this.props.forceBackground;

    const { wrapper, outer, ...inputStyles } = style;

    return (
      <div style={{ ...Styles.wrapper, ...outer }}>
        <div style={{ ...Styles.inputWrapper, ...wrapper }} className="jumperInput">
          <div style={[Styles.background, showBackground ? Styles.backgroundActive : {}]} />
          <input
            {...inputProps}
            key="input"
            style={[
              Styles.input,
              inputStyles,
              showBackground ? Styles.inputFocus : {},
              error ? Styles.inputWithError : {},
            ]}
          />
          <div style={Styles.accessory}>{this.props.accessory}</div>
        </div>
        {extra && <div style={Styles.extra}>{extra}</div>}
        {validationMsg && <div style={Styles.extra}>{validationMsg}</div>}
      </div>
    );
  }
}

Input.propTypes = {
  style: StylePropType,
  placeholder: PropTypes.string,
  extra: PropTypes.element,
  forceBackground: PropTypes.bool,
  validationMsg: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  accessory: PropTypes.node,
};

Input.defaultProps = {
  style: {},
  placeholder: 'Enter your text here...',
  extra: null,
  forceBackground: false,
  validationMsg: false,
  accessory: null,
};

export default Radium(Input);



// WEBPACK FOOTER //
// ./src/components/UIKit/Input/index.js